import { render } from "./Team_manager_adviser_bar_m.vue?vue&type=template&id=1197c782&scoped=true"
import script from "./Team_manager_adviser_bar_m.vue?vue&type=script&lang=js"
export * from "./Team_manager_adviser_bar_m.vue?vue&type=script&lang=js"

import "./Team_manager_adviser_bar_m.vue?vue&type=style&index=0&id=1197c782&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1197c782"

export default script